import axios from "axios";
// import AuthService from './AuthService';
//import { toast } from 'react-toastify';

// axios.defaults.headers.common[ 'x' ] = auth.getJwt();

// axios.defaults.headers.common['Authorization'] = `Bearer ${AuthService.getToken()}`;

// axios.defaults.headers.common['Authorization'] = 'Bearer 718f43b5b1ba4486aeaf26a70bd30f79';
// axios.defaults.headers.common['Accept'] = 'application/vnd.ing.resources.v1+json';

axios.interceptors.response.use(null, (error) => {
  // if 400 and 500
  // console.log('intercepter called');
  // console.log('intercepter called: error', error);
  // toast.error('An error has occurred: ' + error);

  return Promise.reject(error);
});

// axios.interceptors.request.use(
//   (config) => {^
//     // config.headers.genericKey = 'someGenericValue';

//     //  const token = AuthService.getToken();

//     if (token !== null) {
//       // config.headers.common["Authorization"] = `Bearer ${token}`;
//       config.headers.Authorization = `Bearer ${token}`;
//       //     config.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   },
// );

function setAuthorization(value) {
  axios.defaults.headers.common["Authorization"] = value;
}

function setJwt(token) {
  // axios.defaults.headers.common['x-auth-token'] = jwt;

  if (token !== undefined) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
}

const get = async (url, config) => {
  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

const deleteVerb = async (url, config) => {
  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

const post = async (url, data, config) => {
  try {
    // return axios.post(url, data, config);
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    return error;
  }
};

const put = async (url, data, config) => {
  try {
    const response = await axios.put(url, data, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

const p = {
  get: get,
  post: post,
  delete: deleteVerb,
  put: put,
  setJwt,
};

export default p;
